var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bar"},[(_vm.showBack && _vm.backLink)?_c('a',{staticClass:"back",attrs:{"href":_vm.backLink}}):_vm._e(),(_vm.showBack && !_vm.backLink)?_c('a',{staticClass:"back",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}}):_vm._e(),_c('a',{attrs:{"href":"/"}},[_c('div',{class:{
        'nav-bar-logo': true,
        lasting: _vm.showLastingLogo,
        talkspace: !_vm.showLastingLogo,
      }})])])}
var staticRenderFns = []

export { render, staticRenderFns }